import { CallState, LoadingState } from '@lcs/shared/api';
import { createReducer, on } from '@ngrx/store';
import { Tiles } from 'generated/graphql-types';
import { onReset } from 'src/app/authentication/reset-reducer';
import { TileSet } from '../models/tile-set.model';
import { loadTileSet, loadTileSetFailure, loadTileSetSuccess } from './tile-set-type-select.actions';

export const tileSetTypeSelectFeatureKey = 'tileSetTypeSelect';

export interface State {
   callState: CallState;
   tileSets: { [key in Tiles]: TileSet } | {};
}

export const initialState: State = {
   callState: LoadingState.Init,
   tileSets: {},
};

export const reducer = createReducer(
   initialState,
   onReset(initialState),
   on(loadTileSet, (state) => {
      return { ...state, callState: LoadingState.Loading };
   }),
   on(loadTileSetSuccess, (state, action) => {
      const tileId = action.tileSet.tileId;
      const tileSets = tileId ? { ...state.tileSets, [tileId]: action.tileSet } : { ...state.tileSets };
      return {
         ...state,
         callState: LoadingState.Loaded,
         tileSets,
      };
   }),
   on(loadTileSetFailure, (state, action) => {
      return { ...state, callState: { error: action.error } };
   })
);
